export const SORT_DIRECTIONS = Object.freeze(['desc', 'asc']);
export const DEFAULT_SORT_DIRECTION = 'desc';

export const DIRECTIONS = Object.freeze({
  desc: { comparator: '_lt', inclusiveComparator: '_lte', order: 'desc' },
  asc: { comparator: '_gt', inclusiveComparator: '_gte', order: 'asc' },
});

export function buildPageOrderBy(direction) {
  const { order } = DIRECTIONS[direction];
  return [{ timestamp: order }, { id: order }];
}
